import React, { useState, useEffect } from 'react';
import { __ } from '@wordpress/i18n';
import { HashRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import NavBox from './navigation_box/navbox';
import DashboardInnerMain from './dashboard_inner_main/dashboard_inner_main';
import Blocks from './blocks/blocks';
import ThemeCustomizer from './theme_customizer/theme_customizer';
import Wdtemplates from './templates/templates';
import ImportExport from './import_export/import_export';
import CodeSnippets from './code_snippets/code_snippets';
import UtilitiesOptions from './utilities/utilities';
import AdminInterface from './admin_interface/admin_interface';
import Security from './security/security';
// import UpgradeNow from './upgrade_now/upgrade_now';
import ThemeBuilder from './theme_builder/theme_builder';
import MoreProducts from './more_products/more_products';
import Performance from './performance/performance';
import RollBack from './rollback_plugin/rollback';
import Whitelabel from './whitelabel/whitelabel';
import Activate_PRO from './activate_pro/activate_pro';
import SupportToggle from './support_toggle/support';
import NxtWidgetBanner from './nxt_ext_banner/nxt_ext_banner';
import ProNotice from './pro-model/pro-notice';
import WdkInstallPopup from './wdk_install_pop/wdk_install_pop';
import AfterInstallWDKPop from './wdk_install_pop/after_install_wdk_pop';
import { toast } from 'react-toastify';
import Tpgb_Performance from './tpgb_performance/performance';
import Custom_CSS_JS from './custom_css_and_js/custom_css_js';
import Onboarding from './onboarding/onboarding.jsx';
import Tpgb_Settings from './settings/settings';
import VideoPopup from './video-popup/video-popup';
import AI_Compatibility from "./nxt_ai_compatibility/compatibility.jsx";


const DashboardRoutes = ({ isPopupVisible, setIsPopupVisible, isWDKPopupVisible, setIsWDKPopupVisible, isAfterWDKPopupVisible, setIsAfterWDKPopupVisible, selectedWUnique, wdBlockID, setSelectedWUnique, setwdBlockID, setIsPopupType, isPopupType }) => {

    const location = useLocation();
    let pathValue = location.pathname.replace(/^\//, "");

    const page = "nexter_welcome";

    const adminMenu = document
        .getElementById("toplevel_page_nexter_welcome")
        ?.querySelector(".wp-submenu");

    // clear old
    adminMenu?.querySelectorAll(".current")
        ?.forEach((el) => el.classList.remove("current"));
    
    // map old to new
    if (pathValue === "admin_interface" || pathValue === "security" || pathValue === "performance") {
        pathValue = "utilities";
    }

    // match with hash if present
    const selector = pathValue
        ? `[href="admin.php?page=${page}#/${pathValue}"]`
        : `[href="admin.php?page=${page}"]`;

    const newCurrent = adminMenu?.querySelector(selector);

    newCurrent?.classList?.add("current");
    newCurrent?.parentElement?.classList?.add("current");

    const CustomSuccessToast = () => (
        <div className="nxt_success_toast">
            <span className="nxt_success_icon_cover">
                <span className="nxt_success_check_icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 18 18"><g clipPath="url(#a)"><path fill="#0BAA60" d="M8.194.022a9.163 9.163 0 0 0-4.758 1.894c-.687.529-1.578 1.522-2.093 2.332-.222.348-.655 1.236-.81 1.658a10.94 10.94 0 0 0-.451 1.758c-.11.686-.11 1.99 0 2.676.158.972.409 1.754.835 2.623.465.948.948 1.62 1.723 2.399.779.774 1.452 1.257 2.4 1.722.87.426 1.652.676 2.625.834.687.11 1.99.11 2.678 0a8.894 8.894 0 0 0 2.625-.834c.948-.465 1.621-.948 2.4-1.723.775-.778 1.258-1.45 1.723-2.398.31-.63.465-1.042.634-1.676.222-.845.275-1.306.275-2.285 0-.98-.053-1.44-.275-2.286a8.07 8.07 0 0 0-.634-1.676c-.465-.947-.948-1.62-1.723-2.398-.779-.775-1.452-1.257-2.4-1.722a8.761 8.761 0 0 0-2.607-.828c-.518-.08-1.674-.12-2.167-.07Z" /><path fill="#fff" d="M13.722 5.135c.176.056.447.32.521.514a.98.98 0 0 1-.021.722c-.113.229-5.913 5.983-6.174 6.127a.844.844 0 0 1-.803-.003c-.148-.077-2.819-2.469-3.274-2.93a.87.87 0 0 1-.264-.651c.007-.532.398-.891.927-.856.127.01.282.042.342.077.095.046 1.874 1.648 2.452 2.201l.166.162 2.635-2.63c1.449-1.444 2.682-2.652 2.746-2.684.243-.123.461-.137.747-.049Z" /></g><defs><clipPath id="a"><path fill="#fff" d="M0 18h18V0H0z" /></clipPath></defs></svg>
                </span>
                <span className="nxt_success_text">
                    {__('Successfully Saved', 'nexter-extension')}
                </span>
            </span>
            <span className="nxt_success_close_icon_cover" onClick={() => toast.dismiss()}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 20 20"><path fill="#000" d="m11.474 10 3.977 3.977-1.473 1.473L10 11.473 6.023 15.45 4.55 13.977 8.527 10 4.55 6.022 6.023 4.55 10 8.527l3.978-3.978 1.473 1.473L11.474 10Z" /></svg>
            </span>
        </div>
    );

    return (
        <div className={'nxtext_dashinn_main_cover' + (isPopupVisible ? ' nxt-whilbl-enable' : '')}>
            <Routes>
                <Route path="/" element={<DashboardInnerMain />} />
                <Route path="/templates" element={<Wdtemplates />} />

                <Route path="/blocks" element={<Blocks isPopupVisible={isPopupVisible} setIsPopupVisible={setIsPopupVisible} isWDKPopupVisible={isWDKPopupVisible} setIsWDKPopupVisible={setIsWDKPopupVisible} isAfterWDKPopupVisible={isAfterWDKPopupVisible} setIsAfterWDKPopupVisible={setIsAfterWDKPopupVisible} selectedWUnique={selectedWUnique} setSelectedWUnique={setSelectedWUnique} wdBlockID={wdBlockID} setwdBlockID={setwdBlockID} CustomSuccessToast={CustomSuccessToast} isPopupType={isPopupType} setIsPopupType={setIsPopupType} />} />
                <Route path="/theme_builder" element={<ThemeBuilder />} />
                <Route path="/code_snippets" element={<CodeSnippets />} />
                <Route path="/utilities" element={<UtilitiesOptions />} />
                <Route path="/admin_interface" element={<AdminInterface />} />
                <Route path="/security" element={<Security />} />
                <Route path="/more_products" element={<MoreProducts />} />
                <Route path="/performance" element={<Performance />} />
                <Route path="/theme_customizer" element={<ThemeCustomizer />} />
                {(nxtext_ajax_object?.dashData?.nexterThemeActive || nxtext_ajax_object?.dashData?.extensioninstall) &&
                    <Route path="/import-export" element={<ImportExport />} />
                }
                {(nxtext_ajax_object?.dashData?.tpgbinstall || nxtext_ajax_object?.dashData?.extensioninstall) &&
                    <>
                        <Route path="/rollback_plugin" element={<RollBack />} />
                        <Route path="/whitelabel" element={<Whitelabel />} />
                        {/* <Route path="/upgrade_now" element={<UpgradeNow />} /> */}
                        <Route path="/activate_pro" element={<Activate_PRO />} />
                    </>
                }
                {nxtext_ajax_object?.dashData?.tpgbinstall &&
                    <>
                        <Route path="/blocks-settings" element={<Tpgb_Settings CustomSuccessToast={CustomSuccessToast} />} />
                        <Route path="/asset-delivery" element={<Tpgb_Performance />} />
                        <Route path="/custom-css-js" element={<Custom_CSS_JS />} />
                        <Route
							path="/ai-compatibility"
							element={
								<AI_Compatibility
                                isProPopupVisible={isPopupVisible}
							setIsProPopupVisible={setIsPopupVisible}
								/>
							}
						/>
                    </>
                }
            </Routes>
        </div>
    );
};

const Dashboard = () => {
    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const [isPopupType, setIsPopupType] = useState('extension');
    const [isWDKPopupVisible, setIsWDKPopupVisible] = useState(false);
    const [isAfterWDKPopupVisible, setIsAfterWDKPopupVisible] = useState(false);
    const [selectedWUnique, setSelectedWUnique] = useState(null);
    const [wdBlockID, setwdBlockID] = useState(null);
    const [isOnboardingVisible, setIsOnboardingVisible] = useState(null);
    const [isInitialized, setIsInitialized] = useState(false);
    const [skipOnboarding, setSkipOnboarding] = useState(false);

    const [isVideoPopupVisible, setIsVideoPopupVisible] = useState(true);

    useEffect(() => {
        // Remove old key if it exists
        if (localStorage.getItem('nexterWelcomeVideo') !== null) {
            localStorage.removeItem('nexterWelcomeVideo');
        }

        // Read new key only
        const storedValue = localStorage.getItem('nexterWelcomeVideo2');
        if (storedValue !== null) {
            setIsVideoPopupVisible(storedValue === "true");
        }

        const handleEscClose = (event) => {
            if (event.key === "Escape") {
                setIsVideoPopupVisible(false);
                localStorage.setItem('nexterWelcomeVideo2', "false");
            }
        };

        document.addEventListener("keydown", handleEscClose);

        return () => {
            document.removeEventListener("keydown", handleEscClose);
        };
    }, []);

    const handleClosePopup = () => {
        setIsVideoPopupVisible(false);
        localStorage.setItem('nexterWelcomeVideo2', "false");
    };
    
    // track bypass flag
    const [bypassOnboarding, setBypassOnboarding] = useState(false);

    useEffect(() => {
        try {
            const dashData = nxtext_ajax_object.dashData;
            const onboardingDone = dashData?.nxt_onboarding;
            const nexterThemeInstall = dashData?.nexterThemeActive === false && (dashData?.nexterThemeIntall === false || dashData?.nexterThemeIntall === 'available');
            const nexterext = dashData.nexterext === false;
    
            const urlParams = new URLSearchParams(window.location.hash.split('?')[1] || '');
            const skipOnboardingParam = urlParams.get('skip_onboarding') === '1';
    
            setBypassOnboarding(skipOnboardingParam);
    
            // Show onboarding only if onboarding not done AND both nexterThemeInstall and nexterext are false
            const shouldShowOnboarding = !skipOnboardingParam && onboardingDone !== '1' && nexterThemeInstall && nexterext;
    
            setIsOnboardingVisible(shouldShowOnboarding);
        } catch (error) {
            setIsOnboardingVisible(true);
        } finally {
            setIsInitialized(true);
        }
    }, []);

    const completeOnboarding = (onboardingData = {}) => {
        if (Object.keys(onboardingData).length > 0) {
            localStorage.setItem('nxt_onboarding_data', JSON.stringify(onboardingData));
        }
        localStorage.setItem('nxt_onboarding_done', 'true');
        setIsOnboardingVisible(false);
    };

    // conditions
    const shouldShowOnboarding = isInitialized && isOnboardingVisible && !skipOnboarding && !bypassOnboarding;
    const shouldShowDashboard = isInitialized && !isOnboardingVisible && !bypassOnboarding;
    const shouldShowActivateOnly = isInitialized && bypassOnboarding;

    return (
        <Router>
             {shouldShowOnboarding ? (
                <>
                    <Onboarding onComplete={completeOnboarding} isPopupVisible={isPopupVisible} setIsPopupVisible={setIsPopupVisible} setIsPopupType={setIsPopupType} isPopupType={'blocks'} setIsOnboardingVisible={setIsOnboardingVisible} />
                    {isPopupVisible && <ProNotice isPopupVisible={isPopupVisible} setIsPopupVisible={setIsPopupVisible} setIsPopupType={setIsPopupType} isPopupType={'blocks'} isOnboardingVisible={isOnboardingVisible} />}
                </>
            ) : shouldShowActivateOnly ? (
                <div className="nxt_dashboard_main_cover">
                    <div className="nxt_main_cover">
                        <Routes>
                            <Route path="/activate_pro" element={<Activate_PRO />} />
                        </Routes>
                    </div>
                </div>
            ) : shouldShowDashboard ? (
            <div className="nxtext_dashboard_main_cover">
                <div className="nxtext_main_cover">
                    <div className="nxtext_navbox_cover">
                        <NavBox />
                    </div>
                    <DashboardRoutes isPopupVisible={isPopupVisible} setIsPopupVisible={setIsPopupVisible} isWDKPopupVisible={isWDKPopupVisible} setIsWDKPopupVisible={setIsWDKPopupVisible} isAfterWDKPopupVisible={isAfterWDKPopupVisible} setIsAfterWDKPopupVisible={setIsAfterWDKPopupVisible} selectedWUnique={selectedWUnique} wdBlockID={wdBlockID} setSelectedWUnique={setSelectedWUnique} setwdBlockID={setwdBlockID} setIsPopupType={setIsPopupType} isPopupType={isPopupType} />
                </div>

                {!nxtext_ajax_object.pro && !nxtext_ajax_object.tpgb_pro && <NxtWidgetBanner />}

                { isVideoPopupVisible && !((nxtext_ajax_object.pro || nxtext_ajax_object.tpgb_pro) && nxtext_ajax_object?.dashData?.whiteLabel?.nxt_plugin_news == 'on')  && <VideoPopup  isVideoPopupVisible={isVideoPopupVisible} setIsVideoPopupVisible={handleClosePopup} />}

                <SupportToggle />

                {isPopupVisible && <ProNotice isPopupVisible={isPopupVisible} setIsPopupVisible={setIsPopupVisible} setIsPopupType={setIsPopupType} isPopupType={isPopupType} isOnboardingVisible={isOnboardingVisible} />}
                {isWDKPopupVisible && (
                    <WdkInstallPopup isWDKPopupVisible={isWDKPopupVisible} setIsWDKPopupVisible={() => setIsWDKPopupVisible(null)} />
                )}
                {isAfterWDKPopupVisible && (
                    <AfterInstallWDKPop isAfterWDKPopupVisible={isAfterWDKPopupVisible} setIsAfterWDKPopupVisible={() => setIsAfterWDKPopupVisible(null)} wUnique={selectedWUnique} wdblock={wdBlockID} />
                )}
            </div>
            ) : null}
        </Router>
    );
};

export default Dashboard;
